
    import SelectOption from '@/models/SelectOption';
    import _ from 'lodash';
    import { Dictionary } from 'lodash';
    import { Options, Vue } from 'vue-class-component';

    @Options<ApEditInput>({
        props: {
            editing: Boolean,
            title: String,
            value: [String, Number, Boolean],
            valueMap: [Array, Object],
        },
    })
    export default class ApEditInput extends Vue {
        public readonly valueMap!: SelectOption[] | Dictionary<string>;
        public readonly editing!: boolean;
        public readonly value!: string | number | boolean;

        get valueMapInternal() {
            if (!this.valueMap) return null;
            if (_.isArray(this.valueMap)) {
                return _.chain(this.valueMap)
                    .mapKeys((x) => x.id)
                    .mapValues((x) => x.text)
                    .value();
            }
            return this.valueMap;
        }
    }
